// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"aa9bfb91","308":"395f550c","859":"b3d0243f"}[chunkId] + ".chunk.js";
};